module.exports = __webpack_public_path__ + "pnskfsquadron/img/fb-kr.jpg?07320d90";